import React, { useState, useEffect } from "react";
import "./LegalServicesClinic.scss";

import img from "../../assets/Infrastructure/Legal Services Clinic/img (1).jpeg";
import img1 from "../../assets/Infrastructure/Legal Services Clinic/img (2).jpeg";
import img2 from "../../assets/Infrastructure/Legal Services Clinic/img (3).jpeg";
import img3 from "../../assets/Infrastructure/Legal Services Clinic/img (4).jpeg";

const images = [img, img1, img2, img3];

const LegalServicesClinic = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="legal-clinic">
      <div className="container">
        <h1 className="page-title">LEGAL SERVICES CLINIC</h1>

        {/* IMAGE CAROUSEL */}
        <div className="clinic-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={img} alt={`Legal Services Clinic ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div className="content-card">
          <p className="intro">
            Access to Justice
          </p>

          <p>
            The Legal Services Clinic at our college is the
            practical arm of legal education. It provides{" "}
            free legal aid, advice, and legal awareness to the
            underprivileged while offering students hands-on legal training in a
            supervised environment.
          </p>

          <p>
            Operating under the guidelines of the{" "}
            National Legal Services Authority (NALSA), the clinic
            works to ensure access to justice for the poor and marginalized
            sections of society. Students gain experience in{" "}
            legal counselling, drafting, case handling, and community outreach.
          </p>

          <p>
            The Legal Services Clinic serves as a hub for{" "}
            practical learning and social responsibility,
            enabling students to apply classroom knowledge to real-world legal
            challenges while contributing meaningfully to society.
          </p>

          <h2>Activities of the Legal Services Clinic</h2>

          <ul className="activities">
            <li>Legal awareness and outreach programmes</li>
            <li>Client counselling and case management</li>
            <li>Awareness programmes in adopted villages</li>
            <li>our students are para legal volunteers in district legal services authority</li>
            <li>we got an opportunity to attend seminars/workshops in judicial academy where eminent judges are the speakers to guide the students on various topics.</li>
            <li>
              Students serving as Para Legal Volunteers under the
              District Legal Services Authority
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default LegalServicesClinic;
